import React, { memo } from 'react';

import { Status } from 'types/items';

import { PickupsTable } from './PickupsTable';

type Props = {
  startDate?: Date;
  endDate?: Date;
  isDeleting: boolean;
  venue?: string[];
  collectionPoint?: string[];
  onDelete: (ids: string[], onSuccess: () => void) => void;
};

export const PendingPickups = memo<Props>((props) => {
  const { endDate, startDate, venue, collectionPoint } = props;

  return (
    <PickupsTable
      statusKey={Status.PENDING_COUNT}
      status={Status.PENDING_COUNT}
      endDate={endDate}
      startDate={startDate}
      venue={venue}
      collectionPoint={collectionPoint}
    />
  );
});
